module.exports = __webpack_public_path__ + "static/media/22.7770824b.png";